export default "__VITE_ASSET__7lUjl_Gx__"